var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44444 17C4.04722 17 3.70718 16.8629 3.42431 16.5887C3.14144 16.3146 3 15.985 3 15.6V5.8C3 5.415 3.14144 5.08542 3.42431 4.81125C3.70718 4.53708 4.04722 4.4 4.44444 4.4H5.16667V3H6.61111V4.4H12.3889V3H13.8333V4.4H14.5556C14.9528 4.4 15.2928 4.53708 15.5757 4.81125C15.8586 5.08542 16 5.415 16 5.8V15.6C16 15.985 15.8586 16.3146 15.5757 16.5887C15.2928 16.8629 14.9528 17 14.5556 17H4.44444ZM4.44444 15.6H14.5556V8.6H4.44444V15.6ZM4.44444 7.2H14.5556V5.8H4.44444V7.2Z",
    fill: "#3D4AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.6f9efd74f90cedfe966979d7179ab017.svg";
export { ForwardRef as ReactComponent };